"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
;
;
class ApiRisk {
    static getLocations(token) {
        let url = `/risk/locations`;
        return Client_1.default.httpGet(url, token);
    }
    static getOshaLogs(token, locationId, year) {
        let url = `/risk/locations/${locationId}/${year}`;
        return Client_1.default.httpGet(url, token);
    }
    static checkLogStatus(token, logId) {
        let url = `/risk/locations/${logId}`;
        return Client_1.default.httpGet(url, token);
    }
    static requestCertificate(token, certificateRequest) {
        let url = `/risk/osha/certificate`;
        return Client_1.default.httpPost(url, token, certificateRequest);
    }
    static getAvailableEmployees(token) {
        let url = `/risk/employees`;
        return Client_1.default.httpGet(url, token);
    }
    static fileClaim(token, claim) {
        let url = `/risk/claims`;
        return Client_1.default.httpPost(url, token, claim);
    }
    static getLaborLawPosterUrl(token) {
        let url = `/risk/getLaborLawPosterUrl`;
        return Client_1.default.httpGet(url, token);
    }
    static getPicklistOptions(token, objectName, fieldName) {
        const url = `/risk/picklists?object=${encodeURIComponent(objectName)}&field=${encodeURIComponent(fieldName)}`;
        return Client_1.default.httpGet(url, token);
    }
}
exports.default = ApiRisk;
